/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react"
import {
    PhoneContact,
    // LocationContact,
    EmailContact
} from "../../assets/icons/icons";
import gif from "../../assets/images/yes.gif";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
import { useState } from "react";
import axios from "axios";
export default function CotactUs() {
    const { t } = useTranslation();
    UseScrollAnimation();

    const [formData, setFormData] = useState({
        massage_user_name: '',
        massage_user_email: '',
        massage_user_phone: '',
        massage_contant: '',
    });
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');
    const [showModal, setShowModal] = useState(false);

    // Handle input field changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('https://laravel-api.aj-mart.com/api/massages/add', formData, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.data.message) {
                setSuccessMessage(response.data.message);
                setFormData({
                    massage_user_name: '',
                    massage_user_email: '',
                    massage_user_phone: '',
                    massage_contant: '',
                });
                setErrors({});
                setShowModal(true);
            }
        } catch (error) {
            if (error.response && error.response.data && error.response.data.error) {
                setErrors(error.response.data.error);
            }
        }
    };

    // Close the popup modal
    const closeModal = () => {
        setShowModal(false);
    };
    return (
        <>
            <section className="landingPages">
                <div className="container h-full flex flex-col gap-[10px] justify-center">
                    <div className="btmAni30002 text-[35px] font-bold text-white">{t("Contact us")}</div>
                    <div className="btmAni25002 flex items-center gap-[3px] text-white">
                        <Link to={"/"}>{t("Home")}</Link>
                        <span>-</span>
                        <div>{t("Contact us")}</div>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container">
                    <div className="flex flex-col gap-[40px]">
                        <div className="btmAni25002 flex items-center justify-center font-bold text-[25px] capitalize">{t("Get in touch with us")}</div>
                        <div>
                            <form className="flex flex-col gap-[10px]" onSubmit={handleSubmit}>
                                <div className="f-col gap-10 flex justify-between">
                                    <div className="w-100 w-[46%] flex flex-col gap-[10px]">
                                        <div className="flex flex-col gap-[6px]">
                                            <label className="js-scroll fade-top text-[#666666] font-bold">{t("Your Name")}</label>
                                            <input
                                                className="js-scroll fade-btm outline-none border border-[#dadada] py-[7px] px-[20px] rounded-[4px]"
                                                type="text"
                                                name="massage_user_name"
                                                value={formData.massage_user_name}
                                                onChange={handleInputChange}
                                                placeholder={t("Your Name")}
                                            />
                                            {errors.massage_user_name && <span className="text-red-500">{errors.massage_user_name[0]}</span>}
                                        </div>
                                        <div className="flex flex-col gap-[6px]">
                                            <label className="js-scroll fade-top text-[#666666] font-bold">{t("Your Email")}</label>
                                            <input
                                                className="js-scroll fade-btm outline-none border border-[#dadada] py-[7px] px-[20px] rounded-[4px]"
                                                type="email"
                                                name="massage_user_email"
                                                value={formData.massage_user_email}
                                                onChange={handleInputChange}
                                                placeholder={t("Your Email")}
                                            />
                                            {errors.massage_user_email && <span className="text-red-500">{errors.massage_user_email[0]}</span>}
                                        </div>
                                        <div className="flex flex-col gap-[6px]">
                                            <label className="js-scroll fade-top text-[#666666] font-bold">{t("Phone Number")}</label>
                                            <input
                                                className="js-scroll fade-btm outline-none border border-[#dadada] py-[7px] px-[20px] rounded-[4px]"
                                                type="text"
                                                name="massage_user_phone"
                                                value={formData.massage_user_phone}
                                                onChange={handleInputChange}
                                                placeholder={t("Phone Number")}
                                            />
                                            {errors.massage_user_phone && <span className="text-red-500">{errors.massage_user_phone[0]}</span>}
                                        </div>
                                    </div>
                                    <div className="w-100 w-[46%] flex flex-col gap-[10px]">
                                        <label className="js-scroll fade-top text-[#666666] font-bold">{t("Your Message")}</label>
                                        <textarea
                                            className="js-scroll fade-btm h-250 h-[100%] outline-none border border-[#dadada] py-[7px] px-[20px] rounded-[4px]"
                                            name="massage_contant"
                                            value={formData.massage_contant}
                                            onChange={handleInputChange}
                                            placeholder={t("Your Message")}
                                        />
                                        {errors.massage_contant && <span className="text-red-500">{errors.massage_contant[0]}</span>}
                                    </div>
                                </div>
                                <button className="btn js-scroll fade-top" type="submit">{t("Submit")}</button>
                            </form>

                            {/* Success Popup */}
                            {showModal && (
                                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
                                    <div className="bg-white p-6 rounded-[16px] shadow-lg w-[80%] max-w-[500px] h-[300px] text-center flex flex-col gap-[20px] text-center justify-center">
                                        <div className="flex flex-col items-center justify-center gap-[12px]">
                                            <div className="rounded-full">
                                                <img className="w-[95px]" src={gif} alt="" />
                                            </div>
                                            <h3 className="text-xl font-bold text-green-600">{successMessage}</h3>
                                        </div>
                                        <button
                                            className="w-fit mx-auto bg-red-500 py-[5px] px-[30px] font-bold text-white rounded-[4px] capitalize"
                                            onClick={closeModal}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="f-col flex items-center justify-center gap-[20px]">
                            <Link to={"tel:+962 79 077 3377"} className="js-scroll fade-top w-100 border-[2px] border-[#dadada] p-5 flex flex-col h-[200px] w-[270px] items-center justify-center rounded-[4px] gap-[5px]">
                                <PhoneContact />
                                <span className="font-bold">{t("Phone Number")}</span>
                                <span className="text-[#666666] direction-ar">+962 79 077 3377</span>
                            </Link>
                            <Link to={"mailto:info@aj-mart.com"} className="js-scroll fade-btm w-100 border-[2px] border-[#dadada] p-5 flex flex-col h-[200px] w-[270px] items-center justify-center rounded-[4px] gap-[5px]">
                                <EmailContact />
                                <span className="font-bold">{t("Email")}</span>
                                <span className="text-[#666666]">info@aj-mart.com</span>
                            </Link>
                            {/* <Link to={""} className="js-scroll fade-top w-100 border-[2px] border-[#dadada] p-5 flex flex-col h-[200px] w-[270px] items-center justify-center rounded-[4px] gap-[5px]">
                                <LocationContact />
                                <span className="font-bold">{t("Location")}</span>
                                <span className="text-[#666666]">Amman - 7 C - Jordan</span>
                            </Link> */}
                        </div>
                        <div className="f-col flex items-center justify-center gap-[20px]">
                            <Link to={"https://www.facebook.com/people/AJ-Mart/61573171957943/"} className="js-scroll fade-top w-100 border-[2px] border-[#dadada] p-5 flex flex-col h-[200px] w-[270px] items-center justify-center rounded-[4px] gap-[5px]">
                                <img src={require("../../assets/icons/face.svg").default} alt="" />
                                <span className="font-bold">Facebook</span>
                            </Link>
                            <Link to={"https://www.instagram.com/aj_mart.jo/?hl=en"} className="js-scroll fade-btm w-100 border-[2px] border-[#dadada] p-5 flex flex-col h-[200px] w-[270px] items-center justify-center rounded-[4px] gap-[5px]">
                                <img src={require("../../assets/icons/insta.svg").default} alt="" />
                                <span className="font-bold">Instagram</span>
                            </Link>
                            <Link to={"https://wa.link/ppk1jv"} className="js-scroll fade-top w-100 border-[2px] border-[#dadada] p-5 flex flex-col h-[200px] w-[270px] items-center justify-center rounded-[4px] gap-[5px]">
                                <img src={require("../../assets/icons/whats.svg").default} alt="" />
                                <span className="font-bold">Whatsapp</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d216934.94239842123!2d35.782481028239964!3d31.83565368780975!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151b5fb85d7981af%3A0x631c30c0f8dc65e8!2sAmman!5e0!3m2!1sen!2sjo!4v1740469493679!5m2!1sen!2sjo"
                    height="450"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    className="w-full"
                ></iframe>
            </section>
        </>
    )
}
